import ReportMenu from "@domains/common/views/components/ReportMenu/ReportMenu";

import * as S from "./EventMenuBottomSheet.style";

interface EventMenuBottomSheetProps {
  targetEventId: number;
}

const EventMenuBottomSheet = ({ targetEventId }: EventMenuBottomSheetProps) => {
  return (
    <S.BottomSheetContainer
      setting={{ $withBackdropFilter: true, $noPadding: true }}
    >
      <ReportMenu type="EVENT" targetId={targetEventId} />
    </S.BottomSheetContainer>
  );
};

export default EventMenuBottomSheet;
